// features/products/services/useFetchProductsByTenant.ts
import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export type ClienteSlim = { id_client: string }

type ApiClientes = { clientes: ClienteSlim[] } | { data: { clientes: ClienteSlim[] } }

export function useFetchClientsProductsByUsersAndTenant(
  id_tenant: string | undefined,
  opts?: { enabled?: boolean; staleTime?: number; retry?: number }
) {
  const token = useAccessToken()

  return useQuery<ClienteSlim[]>({
    queryKey: ['clientesDoUsuario', id_tenant ?? null],
    enabled: Boolean(token && id_tenant && (opts?.enabled ?? true)),

    staleTime: opts?.staleTime ?? 60_000,
    retry: opts?.retry ?? 1,
    queryFn: async (): Promise<ClienteSlim[]> => {
      const resp = await api.get<ApiClientes>('/products/clientes-do-usuario', {
        headers: { Authorization: `Bearer ${token}` },
        params: id_tenant ? { id_tenant } : undefined
      })

      // Normalize a estrutura da resposta
      const clientes: ClienteSlim[] = ('clientes' in resp.data ? resp.data.clientes : resp.data.data.clientes) ?? []

      // Garante string e unicidade
      const uniqueIds = Array.from(new Set(clientes.map(c => String(c.id_client))))
      const unique: ClienteSlim[] = uniqueIds.map(id_client => ({ id_client }))

      return unique
    }
  })
}
